/* global require module */

var AppDispatcher = require("editor/dispatcher/AppDispatcher");
var IdeConstants = require("editor/constants/IdeConstants");
var ActionTypes = IdeConstants.ActionTypes;

var IdeActions = {
  globalClick: function() {
    "use strict";
    AppDispatcher.dispatch({
      actionType: ActionTypes.IDE_GLOBAL_CLICK
    });
  },

  loadCompleted: function() {
    "use strict";
    AppDispatcher.dispatch({
      actionType: ActionTypes.IDE_LOADED
    });
  }
};

module.exports = IdeActions;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/actions/IdeActions.js
 ** module id = 6
 ** module chunks = 0
 **/